import {
  MultiSelect as TremorMultiSelect,
  MultiSelectItem as TremorMultiSelectItem,
  type MultiSelectProps,
} from '@tremor/react';
import {
  Controller,
  type FieldValues,
  type Control,
  type Path,
} from 'react-hook-form';

import { Label } from '../label';

export type MultiSelectProperties<T extends FieldValues> = Omit<
  MultiSelectProps,
  'children'
> & {
  readonly control: Control<T>;
  readonly name: Path<T>;
  readonly options: ReadonlyArray<{
    readonly value: string;
    readonly label: string;
  }>;
  readonly label?: string;
  readonly errorMessage?: string;
};

export function MultiSelect<T extends FieldValues>({
  control,
  name,
  options,
  label,
  errorMessage,
  ...rest
}: MultiSelectProperties<T>) {
  return (
    <div className='w-full'>
      {label && (
        <div className='mb-2 block'>
          <Label htmlFor={name} value={label} />
        </div>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <TremorMultiSelect
            {...field}
            error={Boolean(errorMessage)}
            errorMessage={errorMessage}
            onValueChange={field.onChange}
            {...rest}
          >
            {options.map((option) => (
              <TremorMultiSelectItem key={option.value} value={option.value}>
                {option.label}
              </TremorMultiSelectItem>
            ))}
          </TremorMultiSelect>
        )}
      />
    </div>
  );
}
